import cn from 'classnames';
import { FC, HTMLProps, useEffect } from 'react';
import { GoCheck } from 'react-icons/go';
import { RiArrowDownSLine } from 'react-icons/ri';
import { getDefaultLang, LangEnum } from '../../helpers/lang';
import { Tooltip } from '../tooltip/tooltip';
import s from './lang-select.module.css';
import { useInputLangStore } from '../../store/use-input-lang-store';

const langs = [
  { id: LangEnum.RU, value: 'RU (Русский)' },
  { id: LangEnum.KZ, value: 'KZ (Қазақша)' },
  { id: LangEnum.EN, value: 'EN (English)' },
  { id: LangEnum.CH, value: 'CH (中文)' },
];

export interface LangSelectProps extends Omit<HTMLProps<HTMLDivElement>, 'onChange'> {
  disabled?: boolean;
  triggerClassname?: string;
  onChange?: (lang: LangEnum) => void;
  withFlags?: boolean;
}

export const LangSelect: FC<LangSelectProps> = (props) => {
  const { className, disabled, triggerClassname, onChange, ...other } = props;
  const { language, setLanguage } = useInputLangStore();

  const selectedItem = langs.find((item) => item.id === language);
  const handleChange = (lang: LangEnum) => {
    onChange?.(lang);
    setLanguage(lang);
  };

  useEffect(() => {
    return () => setLanguage(getDefaultLang());
  }, []);
  
  return (
    <Tooltip
      trigger={
        <div className={s.label} data-testid={other.id} {...other}>
          {selectedItem?.value.split(' ').shift() || ''}
          <RiArrowDownSLine />
        </div>
      }
      disabled={disabled}
      wrapperClassName={cn(s.feature, className, disabled && s.disabled)}
      triggerWrapperClassName={cn(s.trigger, triggerClassname)}
      optionsWrapperClassName={s.optionsWrapper}
      closeOnContentClick
      offset={8}
    >
      <ul className={s.list}>
        {langs.map(({ id, value }) => {
          const isSelected = language === id;

          return (
            <li key={id} className={s.item} onClick={() => handleChange(id)} role="option">
              {value}
              {isSelected && <GoCheck className={s.check} />}
            </li>
          );
        })}
      </ul>
    </Tooltip>
  );
};
